import { format } from 'date-fns';
import settings from '@/settings.js';
export default function hrDateTime (value) {
	if (value && value !== null && value !== '') {
		return format(value, settings.hrsDtFormat);
	} else {
		return '';
	}
}



// WEBPACK FOOTER //
// ./src/filters/hrDateTime.js